import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Wishlist, wishlist } from "../schemas";

export const getTaggedWishlistProps = z
  .object({
    token: z.string(),
    tag: z.number(),
  })
  .extend(requestConfig.shape);

export type GetTaggedWishlistProps = z.infer<typeof getTaggedWishlistProps>;

export const getTaggedWishlist = async (
  args: GetTaggedWishlistProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    tag,
    token,
    proxyAuthSecret,
  } = parseServiceInput(getTaggedWishlistProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/tag/${tag}`, {
    method: "GET",
    headers,
  });

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
